import apiClient from "../../../helpers/apiClient";

/**
 * POST /api/reservation/check-out/:id — finalizes check-out (backend creates past reservation).
 */
export async function completeReservationCheckOut(reservationId, body = {}) {
    const { data } = await apiClient.post(`/api/reservation/check-out/${reservationId}`, body);

    if (!data?.success) {
        throw new Error(data?.message || "Failed to complete check-out");
    }

    return data?.data || null;
}

/**
 * POST /api/reservation/check-out/:id with cash payment (booking registerCheckOutCashPayment).
 */
export async function registerCheckOutCashPayment(reservationId, amount) {
    const normalizedAmount = parseFloat(Number(amount).toFixed(2));

    return completeReservationCheckOut(
        reservationId,
        normalizedAmount > 0 ? { paymentMethod: "cash", amount: normalizedAmount } : {},
    );
}
